import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters.js'
import datavisual from './modules/datavisual.js'
import app from './modules/app.js'
import globalConfig from './modules/globalConfig'
import user from './modules/user.js'
import dict from './modules/dict.js'
import menuRoute from './modules/menuRoute.js'
import tabsView from './modules/tabsView'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    app,
    datavisual,
    globalConfig,
    user,
    dict,
    menuRoute: menuRoute,
    tabsView,
  },
  getters
})

Vue.prototype.skin = store.getters.skin
Vue.prototype.tableHeader = {
  'color': store.getters.skin.headerFontColor,
  'background-color': store.getters.skin.headerBgColor,
  'border-bottom': '1px solid ' + store.getters.skin.headerBorderColor
}
Vue.prototype.formLabel = {
  'color': store.getters.skin.headerFontColor,
  'background-color': store.getters.skin.headerBgColor,
  'border-bottom': '1px solid ' + store.getters.skin.headerBorderColor
}
Vue.prototype.tableListSize = 'small'
Vue.prototype.tableButtonSize = 'small'
Vue.prototype.formSize = 'small'
Vue.prototype.searchButtonSize = 'small'
Vue.prototype.funcButtonSize = 'small'

export default store
